import { BaseDialog } from "@/lib/Components/Dialog/BaseDialog";
import { useGqlMutation } from "@/lib/GraphQLCodegen/fetcher";
import { GenericForm } from "@/lib/Components/Form/Forms/GenericForm";
import { DialogSubmitButton } from "@/lib/Components/Dialog/Components/DialogSubmitButton";
import { LinkIcon } from "@heroicons/react/24/outline";
import { useDialogState } from "@/lib/Components/Dialog/Hooks/useDialogState";
import { InvoiceInput } from "@/app/Invoices/Components/InvoiceInput";
import { assignInvoiceToWorkOrderMutation } from "@/app/ProDrivers/WorkOrders/GraphQL/workOrdersMutations";
import { useTranslations } from "use-intl";

export function AssignInvoiceToWorkOrderDialog({
  workOrderId,
  supplierId,
}: {
  workOrderId: string;
  supplierId?: string;
}) {
  const { mutateAsync } = useGqlMutation(assignInvoiceToWorkOrderMutation);
  const { close } = useDialogState();
  const t = useTranslations("workOrder.dialogs.assignInvoice");

  return (
    <BaseDialog title={t("title")} size="lg">
      <div className="space-y-4">
        <p className="text-sm text-gray-600">{t("description")}</p>

        <GenericForm
          initialValues={{ invoice_id: "" }}
          onSubmit={async (values) => {
            await mutateAsync({
              workOrderId,
              invoiceId: values.invoice_id,
            });

            return close();
          }}
        >
          <InvoiceInput
            name="invoice_id"
            label={t("invoiceLabel")}
            supplierId={supplierId}
            className="col-span-full"
          />

          <DialogSubmitButton
            text={t("submit")}
            color="indigo"
            Icon={LinkIcon}
          />
        </GenericForm>
      </div>
    </BaseDialog>
  );
}
